export default {
    palette: {
        brand: {
            blue: '#209fff',
            green: '#3fc59d',
            pink: '#d94570',
            orange: '#ff9629'
        },
        greyScale: {
            black: 'black',
            darkGrey: '#1b1b1b',
            grey: '#424242',
            lightGrey: '#c8c8c8',
            lighterGrey: '#e7e7e7',
            lightestGrey: '#fbfbfb',
            altGrey: '#cfdde9'
        },
        trafficLight: {
            green: '#15CC35',
            orange: '#FFBE05',
            red: '#FF5F52'
        }
    },
    fontSizes: {
        mouse: '8px',
        rabbit: '14px',
        zebra: '22px',
        elephant: '68px'
    },
    fontTypes: {
        header:
            '"geomanistregular", "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif'
    }
}
